import React from "react";

const successStyles = `
.address-success-page {
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #f0fdf4 50%, #f5f3ff 100%);
  position: relative;
  overflow: hidden;
  font-family: "Inter", "Segoe UI", sans-serif;
}
.success-bg-circle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(65px);
  opacity: .5;
}
.circle-one {
  width: 350px; height: 350px; background: #bfdbfe;
  top: -130px; left: -100px;
}
.circle-two {
  width: 350px; height: 350px; background: #bbf7d0;
  bottom: -140px; right: -100px;
}
.address-success-card {
  width: 100%; max-width: 560px; padding: 45px 38px 30px;
  border-radius: 24px; background: #fff;
  box-shadow: 0 20px 65px rgba(15,23,42,.08), 0 4px 15px rgba(15,23,42,.03);
  text-align: center; position: relative; z-index: 1;
  animation: cardEntrance .75s ease both;
}
.success-icon-wrapper { display: flex; justify-content: center; margin-bottom: 22px; }
.success-icon-ring {
  width: 112px; height: 112px; border-radius: 50%; background: #dcfce7;
  display: flex; align-items: center; justify-content: center;
  animation: pulseRing 2s ease-in-out infinite;
}
.success-icon {
  width: 85px; height: 85px; background: linear-gradient(135deg,#22c55e,#16a34a);
  color: white; border-radius: 50%; display: flex; align-items: center;
  justify-content: center; font-size: 42px; font-weight: 700;
  box-shadow: 0 8px 22px rgba(34,197,94,.25);
  animation: checkPop .6s ease-out both;
}
.success-badge {
  display: inline-flex; align-items: center; gap: 8px; padding: 8px 15px;
  background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0;
  border-radius: 30px; font-size: 12px; font-weight: 700;
  letter-spacing: .3px; margin-bottom: 20px;
}
.success-title { font-size: 30px; font-weight: 800; color: #0f172a; line-height: 1.3; margin: 0 0 14px; }
.success-title span { color: #16a34a; }
.success-description { font-size: 15px; line-height: 1.8; color: #64748b; max-width: 420px; margin: 0 auto 28px; }
.success-info-box {
  display: flex; align-items: center; gap: 14px; text-align: left;
  background: #f0fdf4; border: 1px solid #dcfce7; border-radius: 14px;
  padding: 18px; margin-bottom: 30px;
}
.success-info-icon {
  width: 44px; height: 44px; min-width: 44px; border-radius: 12px;
  background: #dcfce7; color: #16a34a; display: flex; align-items: center;
  justify-content: center; font-size: 25px;
}
.success-info-content { flex: 1; min-width: 0; }
.success-info-content h3 { margin: 0 0 5px; font-size: 14px; font-weight: 700; color: #166534; }
.success-info-content p { margin: 0; font-size: 12px; line-height: 1.6; color: #64748b; }
.success-info-check { color: #22c55e; font-size: 19px; font-weight: 700; }
.success-thanks { border-top: 1px solid #f1f5f9; padding-top: 25px; }
.success-heart { font-size: 23px; color: #f472b6; margin-bottom: 12px; animation: heartBeat 1.8s infinite; }
.success-thanks h2 { font-size: 23px; font-weight: 800; color: #0f172a; margin: 0 0 10px; }
.success-thanks p { font-size: 14px; line-height: 1.8; color: #64748b; max-width: 400px; margin: 0 auto; }
.success-footer {
  margin-top: 30px; padding-top: 18px; border-top: 1px solid #f1f5f9;
  display: flex; align-items: center; justify-content: center; gap: 8px;
}
.success-footer-dot { width: 8px; height: 8px; flex-shrink: 0; background: #22c55e; border-radius: 50%; }
.success-footer p { font-size: 12px; color: #94a3b8; margin: 0; }
@keyframes cardEntrance {
  from { opacity: 0; transform: translateY(35px) scale(.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes checkPop {
  0% { transform: scale(.3); opacity: 0; }
  70% { transform: scale(1.12); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}
@keyframes pulseRing {
  0%,100% { box-shadow: 0 0 0 0 rgba(34,197,94,.15); }
  50% { box-shadow: 0 0 0 14px rgba(34,197,94,0); }
}
@keyframes heartBeat { 0%,100% { transform: scale(1); } 50% { transform: scale(1.2); } }
@media (max-width: 768px) {
  .address-success-card { max-width: 500px; padding: 36px 26px 26px; }
  .success-title { font-size: 26px; }
  .success-description { font-size: 14px; }
}
@media (max-width: 480px) {
  .address-success-page { padding: 18px 12px; }
  .address-success-card { border-radius: 18px; padding: 30px 18px 24px; }
  .success-icon-ring { width: 94px; height: 94px; }
  .success-icon { width: 72px; height: 72px; font-size: 34px; }
  .success-title { font-size: 23px; }
  .success-description { font-size: 13px; margin-bottom: 22px; }
  .success-info-box { gap: 10px; padding: 13px; }
  .success-info-icon { width: 38px; height: 38px; min-width: 38px; font-size: 21px; }
  .success-info-content h3 { font-size: 12px; }
  .success-info-content p { font-size: 11px; }
  .success-thanks h2 { font-size: 21px; }
  .success-thanks p { font-size: 12px; }
  .success-footer p { font-size: 11px; }
}
@media (prefers-reduced-motion: reduce) {
  .address-success-card, .success-icon, .success-icon-ring, .success-heart { animation: none; }
}
`;

const SuccessMessage: React.FC = () => {
  return (
    <>
      <style>{successStyles}</style>

      <div className="address-success-page">
        <div className="success-bg-circle circle-one" />
        <div className="success-bg-circle circle-two" />

        <div className="address-success-card">
          <div className="success-icon-wrapper">
            <div className="success-icon-ring">
              <div className="success-icon" aria-label="Success">
                ✓
              </div>
            </div>
          </div>

          <div className="success-badge">
            <span aria-hidden="true">✓</span>
            <span>Verification Complete</span>
          </div>

          <h1 className="success-title">
            Address Verified <span>Successfully!</span>
          </h1>

          <p className="success-description">
            Great news! Your address verification has been completed
            successfully.
          </p>

          <div className="success-info-box">
            <div className="success-info-icon" aria-hidden="true">
              ⌖
            </div>
            <div className="success-info-content">
              <h3>Address Verification Completed</h3>
              <p>
                Your address details have been successfully submitted and
                verified.
              </p>
            </div>
            <div className="success-info-check" aria-label="Completed">
              ✓
            </div>
          </div>

          <div className="success-footer">
            <span className="success-footer-dot" />
            <p>All done! You may now safely close this page.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessMessage;
